<template lang="pug">
.admin-report-list(fluid)
  v-toolbar(
    dark
    color="indigo"
    flat)
    v-toolbar-title 繳費回報列表
  v-container
    v-layout.py-3
      report-table
</template>

<script>
import ReportTable from "@/components/tables/ReportTable.vue";

export default {
  name: "AdminReportList",
  components: {
    ReportTable
  }
};
</script>
